import React, { forwardRef, HTMLAttributes } from 'react';
import clsx from 'clsx';
import s from './styles/card.module.scss';

interface ICard extends HTMLAttributes<HTMLDivElement> {}

const Card = forwardRef<HTMLDivElement, ICard>(({ children, className, ...rest }, ref) => {
    return (
        <div ref={ref} {...rest} className={clsx(s.root, className)}>
            {children}
        </div>
    );
});

export default Card;
